import React, { useEffect, useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import logo from "assets/img/Logo-Humano.png";
import { Formik } from "formik";
import { isBrowser } from "react-device-detect";
import { NavLink } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { post, addToken, getAnonymous, get, put } from "services";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { SetUser } from "redux/actions/userActions";
import { SetLoggedIn } from "redux/actions/isLoggedInActions";
import { SetLoading } from "redux/actions/loadingActions";
import Spinner from "react-bootstrap/Spinner";
import Constants from "../../utils/constants";
import imageRoute from "../../assets/img/PopUp_Informativo.png";
import queryString from "query-string";
const Swal = require("sweetalert2");
let yup = require("yup");

const marginTopTen = {
  marginTop: 10,
};

const logoStyle = {
  ...marginTopTen,
  width: 150,
  marginRight: 10,
};

const registerWidth = {
  width: "100%",
};

const loadingClases = {
  border: "solid",
  borderRadius: "50%",
  borderRightColor: "transparent",
};

// const getParams = (url) => {
// 	let params = {};
// 	let parser = document.createElement('a');
// 	parser.href = url;
// 	let query = parser.search.substring(1);
// 	let vars = query.split('&');
// 	for (var i = 0; i < vars.length; i++) {
// 		let pair = vars[i].split('=');
// 		params[pair[0]] = decodeURIComponent(pair[1]);
// 	}
// 	return (!params.hasOwnProperty('')) ? params : {};
// };

const Login = (props) => {
  const reRef = useRef();
  const [reCAPTCHA, setReCAPTCHA] = useState("");
  const history = useHistory();

  const schema = yup.object({
    userName: yup.string().required("El usuario es requerido"),
    password: yup.string().required("La contraseña es requerida"),
  });

  // useEffect(() => {
  //   (async function mounted() {
  //     const paramsObject = getParams(props.location.search);
  //     const hasParameters = Object.keys(paramsObject).length !== 0 && paramsObject.constructor === Object;
  //     if (hasParameters && ('username' in paramsObject && 'userGuid' in paramsObject) && (paramsObject.username && paramsObject.userGuid)) {
  //       props.SetLoading(true);
  //       const response = await getAnonymous(`Usuario/ConfirmarUsuarioARSHumano?username=${paramsObject.username}&userGuid=${paramsObject.userGuid}`);
  //       if (response.data.respuesta) {
  //         Swal.fire({
  //           icon: 'success',
  //           title: '¡Usuario validado correctamente!',
  //           text: 'Favor ingresar a sus credenciales para acceder al sistema'
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: '¡Error!',
  //           text: 'Su usuario no ha sido validado'
  //         });
  //       }
  //       props.SetLoading(false);
  //     }
  //   })();
  // }, [])

  const onSumitted = async (data) => {
    props.SetLoading(true);
    let result;

    const usuario = {
      nombre: data.userName,
      clave: data.password,
      Persona: null,
      recaptcha: reCAPTCHA,
    };

    try {
      result = await post(`usuario/Login`, usuario);
      if (result && result.data) {
        //debugger;
        props.SetUser(result.data.usuario);
        localStorage.setItem(
          "currentUser-ARS",
          JSON.stringify(result.data.usuario)
        );
        localStorage.setItem("token-ARS", result.data.token);
        addToken();
        props.SetLoggedIn(true);
        props.SetLoading(false);
        history.push({
          pathname: "/",
          state: {},
        });

        var validarFechaPopUp = await get(
          `SolicitudEmpleoHistorico/HasValidTimeRange/${result.data.usuario.persona.id}`
        );
        var validarParametroPopUp = await get(
          `Parametro/GetByLlave/${Constants.PARAMETRO_POPUP}`
        );
      } else {
        const response = await get(
          `Usuario/ValidateUserStatus?user=${usuario.nombre}`
        );
        Swal.fire({
          icon: "warning",
          title: "Atención",
          text: response.data.message,
        });
        props.SetLoading(false);
        reRef.current.reset();
      }
      var personaId = result.data.usuario.persona.id;
      var confirmar = 0;
      if (validarFechaPopUp.data && validarParametroPopUp.data) {
        showPopup(confirmar, personaId);
      }
    } catch (error) {
      const response = await get(
        `Usuario/ValidateUserStatus?user=${usuario.nombre}`
      );
      //TODO: fcaceres: Agregar mensaje en la consola de que tuvo un bad request porque, en este caso
      // posiblemente no encontro un registro en la tabla personaUsuario
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: response.data.message,
      });

      props.SetLoading(false);
      // Swal.fire({
      //   icon: 'warning',
      //   title: 'Atención',
      //   text: '¡Favor intente nuevamente!'
      // })

      reRef.current.reset();
    } finally {
      props.SetLoading(false);
      reRef.current.reset();
    }
  };

  const showPopup = (datosActualizado, personaId) => {
    Swal.fire({
      showDenyButton: true,
      title: "¿Hay alguna nueva información que necesitemos conocer sobre ti?",
      text: "Si es así, por favor, actualiza tus datos. Si tu información está actualizada presiona el botón rojo para cerrar esta ventana.",
      imageUrl: imageRoute,
      imageWidth: 400,
      imageHeight: 200,
      confirmButtonText: "Si",
      denyButtonText: "No",
    }).then(async (result) => {
      const solicitudEmpleoHistorico = {
        DatosActualizados: result.isConfirmed ? datosActualizado : 1,
        PersonaId: personaId,
      };
      // comentario
      var response = await post(
        `SolicitudEmpleoHistorico`,
        solicitudEmpleoHistorico
      );
    });
  };

  return (
    <div>
      {props.loading ? (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Spinner
            style={loadingClases}
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            animation="border"
            size="lg"
          />
        </div>
      ) : (
        <div></div>
      )}

      <div className="display-flex flex-center center-vertical flex-direction-column height-100 login-background">
        <div className={"padding-10"}>
          <div className={"display-flex flex-end"}>
            <img style={logoStyle} src={logo} alt="logo" />
          </div>

          <Card className="card-login">
            <Card.Body className={"padding-10"}>
              <Formik
                validationSchema={schema}
                onSubmit={onSumitted}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                  userName: "",
                  password: "",
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationFormik01"
                      >
                        <Form.Label>
                          {" "}
                          <strong> Correo </strong>{" "}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="userName"
                          value={values.userName}
                          onChange={handleChange}
                          isValid={touched.userName && !errors.userName}
                          isInvalid={!!errors.userName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.userName}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationFormik02"
                      >
                        <Form.Label>
                          {" "}
                          <strong> Contraseña </strong>{" "}
                        </Form.Label>
                        <Form.Control
                          className="is-password"
                          type="text"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          isValid={touched.password && !errors.password}
                          isInvalid={!!errors.password}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Form.Row>

                    <center style={{ marginBottom: 15 }}>
                      <ReCAPTCHA
                        style={{ marginBottom: 10 }}
                        sitekey={
                          process.env.REACT_APP_NEXT_PUBLIC_RECAPTCHA_SITE_KEY
                        }
                        onChange={setReCAPTCHA}
                        ref={reRef}
                        hl={"es"}
                      />
                    </center>

                    <div
                      className={
                        "display-flex flex-direction-column center-vertical"
                      }
                    >
                      <Button
                        block
                        disabled={reCAPTCHA === ""}
                        variant="dark"
                        type="submit"
                      >
                        <strong> Iniciar sesión </strong>{" "}
                      </Button>

                      <div
                        style={{ marginTop: 15 }}
                        className={"display-flex flex-end-vertical"}
                      >
                        <NavLink to="/changePasswordStepOne" exact>
                          <b> ¿Olvidaste tu contraseña? </b>
                        </NavLink>
                      </div>
                    </div>

                    <center style={{ marginTop: 13 }}>
                      <NavLink to="/register">
                        <Button variant="primary">
                          {" "}
                          <strong> Crear una cuenta </strong>{" "}
                        </Button>
                      </NavLink>
                    </center>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    loading: state.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoggedIn: (value) => dispatch(SetLoggedIn(value)),
    SetLoading: (value) => dispatch(SetLoading(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
